import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'

const DeliverySequence = (props) => {
  const value = props.value || props.sequenceNumber

  return (
    <select
      className={classNames('transition-colors duration-150 ease-in-out h-15 pl-4 pr-10 cursor-pointer bg-white border-grey border bg-chevron-down bg-no-repeat bg-right-4 bg-3 appearance-none rounded-none outline-none focus:border-charcoal hover:border-charcoal truncate', props.className)}
      onChange={(e) => props.onChange(e.target.value)}
      value={value}
    >
      {props.placeholder && (
        <option value="">
          {props.placeholder}
        </option>
      )}

      {props.stockists.map((item, index) => (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  )
}

DeliverySequence.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  stockists: PropTypes.array,
  selected: PropTypes.number,
  value: PropTypes.number,
  sequenceNumber: PropTypes.string
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  stockists: state.auth.account.stockists,
  sequenceNumber: state.auth.account.stockist.sequence_number ?? ''
})

export default connect(mapStateToProps)(DeliverySequence)
